import React, { Component } from "react";
import styles from "./ControlPanel.module.scss";
import logo from "../../../assets/images/vuppetmaster-white.png";
import Dropdown from "../../1_atoms/Dropdown/Dropdown";
import TextEmojiArea from "../../2_molecules/TextEmojiArea/TextEmojiArea";
import SocialBar from "../../1_atoms/SocialBar/SocialBar";
import { cx } from "../../../helpers/ClassNames.helper";
import { t } from "../../../helpers/translate.helper";

class ControlPanel extends Component {

	constructor(props) {
		super(props);

		this.state = {
			avatarIndex: 0,
			voiceIndex: 0,
			backgroundIndex: 0,
			websiteIndex: 0,
			effectIndex: 0,
		};
	}

	setAvatar(entry, index) {
		this.setState({
			...this.state,
			avatar: entry,
			avatarIndex: index,
		});
//		this.props.setAvatar(index);
	}

	setVoice(entry, index) {
		this.setState({
			...this.state,
			voice: entry,
			voiceIndex: index,
		});
	}

	setBackground(entry, index) {
		this.setState({
			...this.state,
			background: entry,
			backgroundIndex: index,
			websiteIndex: 0,
		});
		this.props.setBackground(entry.image);
	}

	setEffect(entry, index) {
		this.setState({
			...this.state,
			effect: entry,
			effectIndex: index,
		});
		this.props.setEffect(index);
	}

	setWebsite(entry, index) {
		this.setState({
			...this.state,
			website: entry,
			websiteIndex: index,
		});
		this.props.setWebsite(index);
	}

	handleSend(message) {
		if (this.props.voices) {
			const voiceObj = this.props.voices[this.state.voiceIndex];
			this.props.speak(message, voiceObj && voiceObj.voice);
		}
	}

	render() {
		const { avatars, voices, backgrounds, effects, websites, playEmote } = this.props;
		const { avatarIndex, voiceIndex, backgroundIndex, websiteIndex, effectIndex } = this.state;

		return (
			<div className={styles.host}>
				<div className={styles.logo}>
					<img src={logo} alt="VuppetMaster" />
				</div>
				<div className={styles.body}>
					<div className={styles.columns}>
						<Dropdown
							label={t('avatar')}
							icon="user"
							entries={avatars}
							selectedIndex={avatarIndex}
							handleSelect={this.setAvatar.bind(this)}
							containerDistance={2}
						/>
						<Dropdown
							label={t('voice')}
							icon="microphone"
							entries={voices}
							selectedIndex={voiceIndex}
							handleSelect={this.setVoice.bind(this)}
							containerDistance={2}
						/>
					</div>

					<div className={styles.columns}>
						<TextEmojiArea
							label={t('text')}
							placeholder={t('text.placeholder')}
							icon="edit"
							handleSend={this.handleSend.bind(this)}
							onAddEmoji={(emoji, event) => playEmote(emoji, true)}
							containerDistance={2}
						/>
					</div>

					<div className={styles.columns}>
						<Dropdown
							label={t('background')}
							icon="image"
							entries={backgrounds}
							selectedIndex={backgroundIndex}
							handleSelect={this.setBackground.bind(this)}
							containerDistance={2}
						/>
						<Dropdown
							label={t('effect')}
							icon="magic"
							entries={effects}
							selectedIndex={effectIndex}
							handleSelect={this.setEffect.bind(this)}
							containerDistance={2}
						/>
					</div>

					<div className={styles.columns}>
						<Dropdown
							label={t('website')}
							icon="globe"
							entries={websites}
							selectedIndex={websiteIndex}
							handleSelect={this.setWebsite.bind(this)}
							containerDistance={2}
						/>
					</div>
					<div className={cx(styles.columns, styles.contact)}>
						<SocialBar />
						<div className={styles.copyright}>{t('copyright')}</div>
						<a className={styles.imprint} href={t('imprint.link')}>{t('imprint')}</a>
					</div>
				</div>
			</div>
		);
	}
}

export default ControlPanel;
